export const STAGE = process.env.VUE_APP_STAGE;
export const SSR_URL = process.env.VUE_APP_SSR_URL;
export const OL_SSR_KEY = 'ol';
export const XPRT_SSR_KEY = 'portal';
